import {
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGOUT,
  USER_LOGOUT_SUCCESS,
  USER_REGISTER_INTEREST,
  USER_MARK_FAVOURITE,
  USER_REGISTER_INTEREST_SUCCESS,
  USER_REGISTER_INTEREST_FAIL,
  USER_SEND_FEEDBACK,
  USER_SEND_FEEDBACK_SUCCESS,
  USER_SEND_FEEDBACK_FAIL,
  USER_FEEDBACK_RESET
} from './constants';

export const login = (
  user, password, next = null, history = null, actionOnSuccess = null
) => ({
  type: USER_LOGIN_REQUEST, user, password, next, history, actionOnSuccess
});
export const loginSuccess = (data) => ({
  type: USER_LOGIN_SUCCESS, data
});
export const loginFail = (error) => ({
  type: USER_LOGIN_FAIL, error
});
export const logout = () => ({
  type: USER_LOGOUT
});
export const logoutSuccess = () => ({
  type: USER_LOGOUT_SUCCESS
});
export const registerInterest = (
  cow, email = null, phone = null, message = null
) => ({
  type: USER_REGISTER_INTEREST, cow, email, phone, message
});
export const registerInterestSuccess = () => ({
  type: USER_REGISTER_INTEREST_SUCCESS
});
export const registerInterestFail = (error) => ({
  type: USER_REGISTER_INTEREST_FAIL, error
});
export const markFavourite = (cow, isFavourite) => ({
  type: USER_MARK_FAVOURITE, cow, isFavourite
});
export const sendFeedback = (message, email) => ({
  type: USER_SEND_FEEDBACK, message, email
});
export const sendFeedbackSuccess = () => ({
  type: USER_SEND_FEEDBACK_SUCCESS
});
export const sendFeedbackFail = (error) => ({
  type: USER_SEND_FEEDBACK_FAIL, error
});
export const resetFeedback = () => ({
  type: USER_FEEDBACK_RESET
});
